// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --hue: 27;
  --sat: 69%;
  --white: hsl(0, 0%, 100%);
  --purple-primary: rgba(132, 0, 255, 1);
  --purple-glow: rgba(132, 0, 255, 0.2);
  --purple-border: rgba(132, 0, 255, 0.8);
  --border-color: #2F293A;
  --background-dark: #120F17;
  color-scheme: light dark;
}

.card-grid {
  display: grid;
  gap: 0.5em;
  padding: 0.75em;
  max-width: 54em;
  font-size: clamp(1rem, 0.9rem + 0.5vw, 1.5rem);
}

.magic-bento-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  aspect-ratio: 4/3;
  min-height: 200px;
  width: 100%;
  max-width: 100%;
  padding: 1.25em;
  border-radius: 20px;
  border: 1px solid var(--border-color);
  background: var(--background-dark);
  font-weight: 300;
  overflow: hidden;
  transition: all 0.3s ease;

  --glow-x: 50%;
  --glow-y: 50%;
  --glow-intensity: 0;
  --glow-radius: 200px;
}

.magic-bento-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.magic-bento-card__header,
.magic-bento-card__content {
  display: flex;
  position: relative;
  color: var(--white);
}

.magic-bento-card__header {
  gap: 0.75em;
  justify-content: space-between;
}

.magic-bento-card__content {
  flex-direction: column;
}

.magic-bento-card__label {
  font-size: 16px;
}

.magic-bento-card__title,
.magic-bento-card__description {
  --clamp-title: 1;
  --clamp-desc: 2;
}

.magic-bento-card__title {
  font-weight: 400;
  font-size: 16px;
  margin: 0 0 0.25em;
}

.magic-bento-card__description {
  font-size: 12px;
  line-height: 1.2;
  opacity: 0.9;
}

.magic-bento-card--text-autohide .magic-bento-card__title,
.magic-bento-card--text-autohide .magic-bento-card__description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.magic-bento-card--text-autohide .magic-bento-card__title {
  -webkit-line-clamp: var(--clamp-title);
  line-clamp: var(--clamp-title);
}

.magic-bento-card--text-autohide .magic-bento-card__description {
  -webkit-line-clamp: var(--clamp-desc);
  line-clamp: var(--clamp-desc);
}

@media (max-width: 599px) {
  .card-grid {
    grid-template-columns: 1fr;
    width: 90%;
    margin: 0 auto;
    padding: 0.5em;
  }

  .magic-bento-card {
    width: 100%;
    min-height: 180px;
  }
}

@media (min-width: 600px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .card-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  .magic-bento-card:nth-child(3) {
    grid-column: span 2;
    grid-row: span 2;
  }

  .magic-bento-card:nth-child(4) {
    grid-column: 1 / span 2;
    grid-row: 2 / span 2;
  }

  .magic-bento-card:nth-child(6) {
    grid-column: 4;
    grid-row: 3;
  }
}

/* Border glow effect */
.magic-bento-card--border-glow::after,
.particle-container--border-glow::after {
  content: '';
  position: absolute;
  inset: 0;
  padding: 6px;
  background: radial-gradient(
    var(--glow-radius) circle at var(--glow-x) var(--glow-y),
    rgba(132, 0, 255, calc(var(--glow-intensity) * 0.8)) 0%,
    rgba(132, 0, 255, calc(var(--glow-intensity) * 0.4)) 30%,
    transparent 60%
  );
  border-radius: inherit;
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.magic-bento-card--border-glow:hover::after,
.particle-container--border-glow:hover::after {
  opacity: 1;
}

.magic-bento-card--border-glow:hover,
.particle-container--border-glow:hover {
  box-shadow:
    0 4px 20px rgba(46, 24, 78, 0.4),
    0 0 30px var(--purple-glow);
}

.particle-container {
  position: relative;
  overflow: hidden;
  --glow-x: 50%;
  --glow-y: 50%;
  --glow-intensity: 0;
  --glow-radius: 200px;
}

.particle::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: rgba(132, 0, 255, 0.2);
  border-radius: 50%;
  z-index: -1;
}

.particle-container:hover {
  /* Only apply shadows if we are not explicitly a button that already handles it */
}

/* Global spotlight styles */
.global-spotlight {
  mix-blend-mode: screen;
  will-change: transform, opacity;
  z-index: 200 !important;
  pointer-events: none;
}

.bento-section {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/MagicBento.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,sCAAsC;EACtC,qCAAqC;EACrC,uCAAuC;EACvC,uBAAuB;EACvB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;;EAEzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;IACV,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ;;;;;GAKC;EACD,sBAAsB;EACtB;;6BAE2B;EAC3B,2BAA2B;EAC3B;;6BAE2B;EAC3B,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE;;+BAE6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iFAAiF;AACnF;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":[":root {\n  --hue: 27;\n  --sat: 69%;\n  --white: hsl(0, 0%, 100%);\n  --purple-primary: rgba(132, 0, 255, 1);\n  --purple-glow: rgba(132, 0, 255, 0.2);\n  --purple-border: rgba(132, 0, 255, 0.8);\n  --border-color: #2F293A;\n  --background-dark: #120F17;\n  color-scheme: light dark;\n}\n\n.card-grid {\n  display: grid;\n  gap: 0.5em;\n  padding: 0.75em;\n  max-width: 54em;\n  font-size: clamp(1rem, 0.9rem + 0.5vw, 1.5rem);\n}\n\n.magic-bento-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  aspect-ratio: 4/3;\n  min-height: 200px;\n  width: 100%;\n  max-width: 100%;\n  padding: 1.25em;\n  border-radius: 20px;\n  border: 1px solid var(--border-color);\n  background: var(--background-dark);\n  font-weight: 300;\n  overflow: hidden;\n  transition: all 0.3s ease;\n\n  --glow-x: 50%;\n  --glow-y: 50%;\n  --glow-intensity: 0;\n  --glow-radius: 200px;\n}\n\n.magic-bento-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.magic-bento-card__header,\n.magic-bento-card__content {\n  display: flex;\n  position: relative;\n  color: var(--white);\n}\n\n.magic-bento-card__header {\n  gap: 0.75em;\n  justify-content: space-between;\n}\n\n.magic-bento-card__content {\n  flex-direction: column;\n}\n\n.magic-bento-card__label {\n  font-size: 16px;\n}\n\n.magic-bento-card__title,\n.magic-bento-card__description {\n  --clamp-title: 1;\n  --clamp-desc: 2;\n}\n\n.magic-bento-card__title {\n  font-weight: 400;\n  font-size: 16px;\n  margin: 0 0 0.25em;\n}\n\n.magic-bento-card__description {\n  font-size: 12px;\n  line-height: 1.2;\n  opacity: 0.9;\n}\n\n.magic-bento-card--text-autohide .magic-bento-card__title,\n.magic-bento-card--text-autohide .magic-bento-card__description {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.magic-bento-card--text-autohide .magic-bento-card__title {\n  -webkit-line-clamp: var(--clamp-title);\n  line-clamp: var(--clamp-title);\n}\n\n.magic-bento-card--text-autohide .magic-bento-card__description {\n  -webkit-line-clamp: var(--clamp-desc);\n  line-clamp: var(--clamp-desc);\n}\n\n@media (max-width: 599px) {\n  .card-grid {\n    grid-template-columns: 1fr;\n    width: 90%;\n    margin: 0 auto;\n    padding: 0.5em;\n  }\n\n  .magic-bento-card {\n    width: 100%;\n    min-height: 180px;\n  }\n}\n\n@media (min-width: 600px) {\n  .card-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .card-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .magic-bento-card:nth-child(3) {\n    grid-column: span 2;\n    grid-row: span 2;\n  }\n\n  .magic-bento-card:nth-child(4) {\n    grid-column: 1 / span 2;\n    grid-row: 2 / span 2;\n  }\n\n  .magic-bento-card:nth-child(6) {\n    grid-column: 4;\n    grid-row: 3;\n  }\n}\n\n/* Border glow effect */\n.magic-bento-card--border-glow::after,\n.particle-container--border-glow::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  padding: 6px;\n  background: radial-gradient(\n    var(--glow-radius) circle at var(--glow-x) var(--glow-y),\n    rgba(132, 0, 255, calc(var(--glow-intensity) * 0.8)) 0%,\n    rgba(132, 0, 255, calc(var(--glow-intensity) * 0.4)) 30%,\n    transparent 60%\n  );\n  border-radius: inherit;\n  -webkit-mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  mask-composite: exclude;\n  pointer-events: none;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n  z-index: 1;\n}\n\n.magic-bento-card--border-glow:hover::after,\n.particle-container--border-glow:hover::after {\n  opacity: 1;\n}\n\n.magic-bento-card--border-glow:hover,\n.particle-container--border-glow:hover {\n  box-shadow:\n    0 4px 20px rgba(46, 24, 78, 0.4),\n    0 0 30px var(--purple-glow);\n}\n\n.particle-container {\n  position: relative;\n  overflow: hidden;\n  --glow-x: 50%;\n  --glow-y: 50%;\n  --glow-intensity: 0;\n  --glow-radius: 200px;\n}\n\n.particle::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  background: rgba(132, 0, 255, 0.2);\n  border-radius: 50%;\n  z-index: -1;\n}\n\n.particle-container:hover {\n  /* Only apply shadows if we are not explicitly a button that already handles it */\n}\n\n/* Global spotlight styles */\n.global-spotlight {\n  mix-blend-mode: screen;\n  will-change: transform, opacity;\n  z-index: 200 !important;\n  pointer-events: none;\n}\n\n.bento-section {\n  position: relative;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
